import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ConnectionStateService {
    private connectionModalOpenSubject$ = new BehaviorSubject<boolean>(false);

    getConnectionStateObservable(): Observable<boolean> {
        return this.connectionModalOpenSubject$.pipe();
    }

    getConnectionState(): boolean {
        return this.connectionModalOpenSubject$.value;
    }

    setConnectionState(isConnected: boolean): void {
        this.connectionModalOpenSubject$.next(isConnected);
    }
}
